
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DoneIcon from '@mui/icons-material/Done';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import TableCell from '@mui/material/TableCell';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';


import { IconButton, Switch, Tooltip } from '@mui/material';


const ProjectRow = ({ row, updateForm, index, onDelete }) => {
  return (
    <>
      <TableCell component="th" align="center" scope="row" key={index}>
        {row.IdCity}
      </TableCell>
      <TableCell align="center" key={index}>{row.UF}</TableCell>
      <TableCell align="center" key={index}>{row.City}</TableCell>
      <TableCell align="center" key={index}>{row.Project}</TableCell>
      <TableCell align="center" key={index}>
        <Tooltip title="Edit">
          <IconButton onClick={() => { updateForm(row) }}>
            <ModeEditOutlineOutlinedIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton onClick={() => { onDelete(row.IdCity) }}>
            <DeleteForeverOutlinedIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </>
  );
}

export default ProjectRow;